import api from './api';

/** Course variants (Tranche E, #489): translations and Leichte Sprache of v2 courses. */
export type VariantKind = 'translation' | 'easy_language';
export type VariantJobStatus = 'pending' | 'processing' | 'completed' | 'failed';

export interface VariantJob {
    id: number;
    sourceCourseId: number;
    targetLanguage: string;
    kind: VariantKind;
    status: VariantJobStatus;
    progressLabel: string;
    totalLessons: number;
    completedLessons: number;
    skippedLessons: string[];
    resultCourseId: number | null;
    errorMessage: string | null;
    createdAt: string;
    completedAt: string | null;
}

export interface VariantLanguage {
    code: string;
    label: string;
    nativeLabel: string;
    tier: 'approved' | 'review';
}

export interface FamilyMember {
    id: number;
    title: string;
    language: string;
    languageLabel: string;
    nativeLabel: string;
    kind: VariantKind | null;
    isOriginal: boolean;
    isCurrent: boolean;
    isActive: boolean;
    qualityTier: 'approved' | 'review' | null;
    outdated: boolean | null;
    signedOffAt: string | null;
}

export interface CourseFamily {
    courseId: number;
    originalId: number;
    language: string;
    kind: VariantKind | null;
    variants: FamilyMember[];
}

export const isVariantJobRunning = (status: VariantJobStatus): boolean => status === 'pending' || status === 'processing';

export const variantService = {
    async create(input: { sourceCourseId: number; kind: VariantKind; targetLanguage?: string }): Promise<VariantJob> {
        const { data } = await api.post('/ai/course-variants', input);
        return data;
    },
    async languages(): Promise<VariantLanguage[]> {
        const { data } = await api.get('/ai/course-variants/languages');
        return data.languages;
    },
    async jobs(courseId: number): Promise<VariantJob[]> {
        const { data } = await api.get(`/ai/courses/${courseId}/variant-jobs`);
        return data;
    },
    async family(courseId: number): Promise<CourseFamily> {
        const { data } = await api.get(`/ai/courses/${courseId}/variants`);
        return data;
    },
};

export default variantService;
